import styled from 'styled-components';

const FormContent = styled.div`
  margin-bottom: 32px;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

export default FormContent;
